import { EventsStringService } from "src/app/shared/services/events-string.service";
import { EventIdRegistryService } from "src/app/shared/services/event-id-registry.service";
import { BlocklyHelperService } from "../blockly-helper.service";
import { BLOCKLY_BLOCK_PREFIX, BLOCKLY_COLORS, BLOCKLY_DUMMY, BlocklyToolboxCategory } from "../blocky-types.types";
import { registerCategorizedEventDropdown } from "../field-dependent-event-dropdown";
import { registerEventIdDropdownBlock } from "../field-event-id-dropdown";

export function BlocklyCategory_EVENTS(name: string = "unnamed", BH: BlocklyHelperService, eventStrings: EventsStringService, eventIdRegistry: EventIdRegistryService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', colour: BLOCKLY_COLORS.EVENTS, name: name, contents: [] };



  const secondsArray = Array.from({ length: 60 }, (_, i) => i.toString());
  const timeSelectors = "{{hh:dropdown=0,1,2,3}}:{{mm:dropdown=" + secondsArray.join(',') + " }}:{{ss:dropdown=" + secondsArray.join(',') + "}}";

  // Register the categorized event dropdown block (idempotent - skips if already registered)
  registerCategorizedEventDropdown(eventStrings);
  // Register the event ID dropdown block (idempotent)
  registerEventIdDropdownBlock(eventIdRegistry);
  // EVENT_ALL, EVENT_ALL_RAW nur registrieren (veraltet), TIME_SECONDS ausblenden
  BH.eventDropdown("EVENT_ALL", eventStrings.get());
  BH.eventDropdown("EVENT_ALL_RAW", eventStrings.getRaw());
  BH._custom("TIME_SECONDS", "@output:SECONDS\n⏰ Zeit" + timeSelectors, "RAGAI.HELPER.timeToSeconds({{hh}},{{mm}},{{ss}})", { colour: BLOCKLY_COLORS.RAGAI_DARK });

  cat.contents = [
    { kind: 'block' as const, type: 'EVENT_CATEGORIZED' },
    { kind: 'block' as const, type: 'EVENT_DATA_CATEGORIZED' }
  ];

  cat.contents.push(BH.label("Ereignisse"));
  cat.contents.push(
    BH.withNested(
      BH.eventOn("EVENTS_ON_NEW", "Globales reagieren auf Ereignis vom Typ:\n {{eventName[@check=EVENT]}}\nführe aus:{{action:statement[@check=ACTION]}}Merken als:{{eventId:text}}", `
        if(!RAGAI.EVENTS._disabled) RAGAI.EVENTS._disabled = {};
        var __evtDis = await RAGAI.KEYVAL.get("evt_disabled_"+{{eventId}}, "EVENT-MANAGER");
        if(__evtDis) RAGAI.EVENTS._disabled[{{eventId}}] = true;
        RAGAI.EVENTS.on({{eventName}},
         async function(eventName, eventData){
         if(RAGAI.EVENTS._disabled[{{eventId}}]) return;
         {{action}}

          }, {{eventId}});
          `, { colour: BLOCKLY_COLORS.EVENTS, inputsInline: true, hat: "cap", connection: "none" }),
      [
        { forValue: "eventName", isShadow: true, targetBlockType: "EVENT_CATEGORIZED" }

      ]
    )
  );

  cat.contents.push(
    BH.withNested(
      BH.eventOn("EVENTS_ON_NEW_ONCE", "Einmaliges reagieren auf das nächste Ereignis vom Typ:\n {{eventName[@check=EVENT]}}\n{{action:statement[@check=ACTION]}}", `
        let eventId = Math.random().toString(36).substring(2, 15)+"____"+Math.random().toString(36).substring(2, 15);
        RAGAI.VARIABLES[eventId] = RAGAI.EVENTS.on({{eventName}},
         async function(eventName, eventData){
         {{action}}

         // DEL
            RAGAI.EVENTS.off(RAGAI.VARIABLES[eventId]);
            delete RAGAI.VARIABLES[eventId];

          });
          `, { colour: BLOCKLY_COLORS.EVENTS, inputsInline: true }),
      [
        { forValue: "eventName", isShadow: true, targetBlockType: "EVENT_CATEGORIZED" }

      ]
    )
  );


  // Einzelne Blöcke nur registrieren (Abwärtskompatibilität)
  BH._custom("EVENT_DISABLE", BLOCKLY_BLOCK_PREFIX.EVENTS + "Ereignis deaktivieren: {{eventId}}", "if(!RAGAI.EVENTS._disabled) RAGAI.EVENTS._disabled = {};\nRAGAI.EVENTS._disabled[{{eventId}}] = true;\nawait RAGAI.KEYVAL.set(\"evt_disabled_\"+{{eventId}}, true, \"EVENT-MANAGER\");\n", { colour: BLOCKLY_COLORS.EVENTS, inputsInline: true });
  BH._custom("EVENT_ENABLE", BLOCKLY_BLOCK_PREFIX.EVENTS + "Ereignis aktivieren: {{eventId}}", "if(RAGAI.EVENTS._disabled) delete RAGAI.EVENTS._disabled[{{eventId}}];\nawait RAGAI.KEYVAL.deleteKeyValEntry(\"evt_disabled_\"+{{eventId}}, \"EVENT-MANAGER\");\n", { colour: BLOCKLY_COLORS.EVENTS, inputsInline: true });
  BH._custom("EVENT_OFF", BLOCKLY_BLOCK_PREFIX.EVENTS + "Ereignis entfernen: {{eventId}}", "RAGAI.EVENTS.off({{eventId}});\nif(RAGAI.EVENTS._disabled) delete RAGAI.EVENTS._disabled[{{eventId}}];\nawait RAGAI.KEYVAL.deleteKeyValEntry(\"evt_disabled_\"+{{eventId}}, \"EVENT-MANAGER\");\n", { colour: BLOCKLY_COLORS.EVENTS, inputsInline: true });

  cat.contents.push(
    BH.withNested(
      BH._custom("EVENT_MANAGE", BLOCKLY_BLOCK_PREFIX.EVENTS + "Ereignis {{action:dropdown=⏸️ deaktivieren|disable,▶️ aktivieren|enable,🗑️ entfernen|remove}}: {{eventId}}", `await RAGAI.EVENTS.manage('{{action}}', {{eventId}});`, { colour: BLOCKLY_COLORS.EVENTS, inputsInline: true }),
      [
        { forValue: "eventId", isShadow: true, targetBlockType: "EVENT_ID_DROPDOWN" }
      ])
  );


  /*
    const allevents: Map<string, [string, string][]> = new Map<string, [string, string][]>();
    allevents.set("youtube", [
      ["Playing", "EINSb"],
      ["Pause", "EINSb"],
      ["Play", "ZWE"],
      ["Stop", "DREI"]
    ]);
    allevents.set("VIMEO", [
      ["a", "b"],
      ["ac", "b"],
      ["ab", "b"]]
    );




    allevents.forEach((events, key) => {
      if (cat.contents) {
        cat.contents.push(
          BH._custom(
            `EVENT_COLLECTION_${key}`,
            `@output:EVENT\n${key}-Event:{{eventName:dropdown=${events.map(e => e[0] + "|" + e[1]).join(",")}}}`,
            "'{{eventName}}'",
            { colour: BLOCKLY_COLORS.EVENTS_LIGHT }
          )
        );
      }
    });
   */



  // EVENT_TRIGGER nur registrieren (veraltet)
  BH.withNested(
    BH._custom("EVENT_TRIGGER", BLOCKLY_BLOCK_PREFIX.EVENTS + "Ereignis auslösen: {{eventName}}", "RAGAI.EVENTS.trigger({{eventName}}, {{eventData}});", { colour: BLOCKLY_COLORS.EVENTS, inputsInline: true }),
    [
      { forValue: "eventName", isShadow: true, targetBlockType: "EVENT_COLLECTION_CUSTOM" }
    ]);

  cat.contents.push(
    BH.withNested(
      BH._custom("EVENT_TRIGGER_NEW", BLOCKLY_BLOCK_PREFIX.EVENTS + "Ereignis auslösen: {{eventName[@check=EVENT]}}\nEreigniswerte: {{?eventData[@check=RAGAIOBJ]}}", "RAGAI.EVENTS.trigger({{eventName}}, {{eventData}});", { colour: BLOCKLY_COLORS.EVENTS, inputsInline: true }),
      [
        { forValue: "eventName", isShadow: true, targetBlockType: "EVENT_CATEGORIZED" },
        { forValue: "eventData", isShadow: true, targetBlockType: BLOCKLY_DUMMY.RAGAIOBJ, targetBlockDefaults: { obj: '{}' } }
      ])
  );




  cat.contents.push(
    BH.withNested(
      BH.action("CALL_LATER", "Verzögert ausführen {{time[@check=SECONDS]}} {{actions:statement}}", "RAGAI.WAITFOR.secondsAndExec({{time}}, async function() { {{actions}} });\n")
      , [{ forValue: 'time', isShadow: true, targetBlockType: BLOCKLY_DUMMY.SECONDS }]),
  );


  cat.contents.push(BH.label("Experten"));

  cat.contents.push(BH._custom("EVENT_DEBUG", "🔻 im Chatverlauf debuggen 🔎", `
      RAGAI.CARDS.debugEvent("<div class='alert alert-info'><b>🔻.Name = "+eventName+"</b><pre>🔻.Daten = "+JSON.stringify(eventData, null, 2)+"</pre></div>");
      `, { colour: BLOCKLY_COLORS.EVENTS_LIGHT, inputsInline: true }));


  cat.contents.push(BH._custom('EVENT_COLLECTION_CUSTOM', `@output:EVENT\n${BLOCKLY_BLOCK_PREFIX.EVENTS}{{eventName:text}}`, "{{eventName}}", {
    colour: BLOCKLY_COLORS.EVENTS_LIGHT
  }));



  cat.contents.push(BH._custom("EVENT_DATA_OBJECT_ATTRIBUTE", "@output:String\n🔻.Daten.{{key:text}}", "eventData.{{key!}}", { colour: BLOCKLY_COLORS.EVENTS_LIGHT }));
  cat.contents.push(BH._custom("EVENT_DATA_OBJECT", "@output:String\n🔻. {{key:dropdown=Name|eventName,Daten|eventData}}", "{{key}}", { colour: BLOCKLY_COLORS.EVENTS_LIGHT }));
  cat.contents.push(BH.castTypeBlock("EVENT"));






  return cat;

}
